import { TableCard } from '../../../../components'
import { EmpresasListHeader } from './components/header/EmpresasListHeader'
import { ListFiltersProvider } from './core/ListFiltersProvider'
import { ListViewProvider } from './core/ListViewProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { EmpresasTable } from './table/EmpresasTable'

const EmpresasList = () => {
  return (
    <TableCard>
      <EmpresasListHeader />
      <EmpresasTable />
    </TableCard>
  )
}

export const EmpresasListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <ListFiltersProvider>
          <EmpresasList />
        </ListFiltersProvider>
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
